(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wiki-blog-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid=document.getElementById('wbxGrid');
  if(!grid) return;
  var search=document.getElementById('wbxSearch');
  var empty=document.getElementById('wbxEmpty');
  var filters=document.getElementById('wbxFilters');
  var items=Array.prototype.slice.call(grid.querySelectorAll('.wbx__item'));
  var state={q:'',tag:''};
  function norm(v){return (v||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');}
  function apply(){
    var q=norm(state.q.trim()),shown=0;
    items.forEach(function(it){
      var name=norm(it.getAttribute('data-title'));
      var tags=it.getAttribute('data-tags')||'';
      var okQ=!q||name.indexOf(q)>-1;
      var okT=!state.tag||('|'+tags+'|').indexOf('|'+state.tag+'|')>-1;
      var ok=okQ&&okT; it.hidden=!ok; if(ok)shown++;
    });
    if(empty) empty.hidden=shown!==0;
  }
  if(search) search.addEventListener('input',function(){state.q=search.value;apply();});
  if(filters){
    filters.addEventListener('click',function(e){
      var b=e.target.closest('.wbx__chip'); if(!b) return;
      state.tag=b.getAttribute('data-value');
      Array.prototype.forEach.call(filters.querySelectorAll('.wbx__chip'),function(x){x.classList.toggle('is-active',x===b);});
      apply();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiki-plante-fiche"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rail=document.getElementById('wktRail');
  if(!rail) return;
  var svg=document.getElementById('wktSvg');
  var pathBg=document.getElementById('wktPathBg'), pathFg=document.getElementById('wktPathFg');
  var pins=document.getElementById('wktPins'), marker=document.getElementById('wktMarker');
  var trail=document.getElementById('wktTrail');
  var stops=Array.prototype.slice.call(document.querySelectorAll('.wkt__stop'));
  var NS='http://www.w3.org/2000/svg', W=130, amp=36, len=0;

  function buildPath(){
    var H=rail.offsetHeight;
    // Largeur réelle du rail (130px desktop, 64px mobile) — sinon le chemin déborde sur le contenu.
    W=rail.offsetWidth||130; amp=W*0.28;
    svg.setAttribute('width',W); svg.setAttribute('height',H); svg.setAttribute('viewBox','0 0 '+W+' '+H);
    var d='M '+(W/2)+' 0';
    for(var y=0;y<=H;y+=20){ var x=W/2 + Math.sin(y/150)*amp; d+=' L '+x.toFixed(1)+' '+y; }
    pathBg.setAttribute('d',d); pathFg.setAttribute('d',d);
    len=pathFg.getTotalLength();
    pathFg.style.strokeDasharray=len; pathFg.style.strokeDashoffset=len;
    pins.innerHTML='';
    stops.forEach(function(sec,i){
      var t=stops.length>1 ? i/(stops.length-1) : 0;
      var pt=pathFg.getPointAtLength(len*(0.01+t*0.97));
      var last=(i===stops.length-1) && sec.classList.contains('wkt__stop--dest');
      var g=document.createElementNS(NS,'g');
      var c=document.createElementNS(NS,'circle');
      c.setAttribute('cx',pt.x); c.setAttribute('cy',pt.y); c.setAttribute('r',last?15:13);
      c.setAttribute('fill',last?'#2C5638':'#fff'); c.setAttribute('stroke','#4B7A54'); c.setAttribute('stroke-width','3');
      var tx=document.createElementNS(NS,'text');
      tx.setAttribute('x',pt.x); tx.setAttribute('y',pt.y+(last?5:4)); tx.setAttribute('text-anchor','middle');
      tx.setAttribute('font-size',last?'14':'12'); tx.setAttribute('font-weight','700');
      tx.setAttribute('fill',last?'#fff':'#2C5638'); tx.setAttribute('font-family','Inter,sans-serif');
      tx.textContent=last?'★':(i+1);
      g.appendChild(c); g.appendChild(tx); pins.appendChild(g);
    });
  }
  function upd(){
    var top=trail.offsetTop, h=trail.offsetHeight;
    var p=(window.scrollY+window.innerHeight*0.5-top)/h; p=Math.min(Math.max(p,0),1);
    pathFg.style.strokeDashoffset=len*(1-p);
    var pt=pathFg.getPointAtLength(len*p);
    marker.style.left=pt.x+'px'; marker.style.top=pt.y+'px';
    var trig=window.scrollY+window.innerHeight*0.78;
    stops.forEach(function(sec){ if(sec.getBoundingClientRect().top+window.scrollY<trig) sec.classList.add('in'); });
  }
  function boot(){ buildPath(); upd(); }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',function(){ buildPath(); upd(); });
  if(document.readyState==='complete') boot(); else window.addEventListener('load',boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiki-plantes-index"] && !Shopify.designMode) return;
  try {
    
(function(){
  var grid = document.getElementById('wkxGrid');
  if(!grid) return;
  var search = document.getElementById('wkxSearch');
  var empty = document.getElementById('wkxEmpty');
  var filters = document.getElementById('wkxFilters');
  var items = Array.prototype.slice.call(grid.querySelectorAll('.wkx__item'));
  var state = { q:'', usage:'', prop:'' };

  function norm(v){ return (v||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");  }

  function apply(){
    var q = norm(state.q.trim());
    var shown = 0;
    items.forEach(function(it){
      var name = norm(it.getAttribute('data-name'));
      var latin = norm(it.getAttribute('data-latin'));
      var prop = it.getAttribute('data-prop') || '';
      var usage = it.getAttribute('data-usage') || '';
      var okQ = !q || name.indexOf(q) > -1 || latin.indexOf(q) > -1;
      var okU = !state.usage || ('|'+usage+'|').indexOf('|'+state.usage+'|') > -1;
      var okP = !state.prop || ('|'+prop+'|').indexOf('|'+state.prop+'|') > -1;
      var ok = okQ && okU && okP;
      it.hidden = !ok;
      if(ok) shown++;
    });
    if(empty) empty.hidden = shown !== 0;
  }

  if(search) search.addEventListener('input', function(){ state.q = search.value; apply(); });

  if(filters){
    filters.addEventListener('click', function(e){
      var btn = e.target.closest('.wkx__chip');
      if(!btn) return;
      var type = btn.getAttribute('data-filter');
      state[type] = btn.getAttribute('data-value');
      var group = btn.parentNode.querySelectorAll('.wkx__chip');
      Array.prototype.forEach.call(group, function(b){ b.classList.toggle('is-active', b === btn); });
      apply();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
